import { useState } from "react";
import { RefreshCw } from "lucide-react";

const CERTS = [
  { id: "cisco", vendor: "Cisco", title: "CCNP Enterprise", back: "Your network is designed the way big enterprises do it — proper routing, VLANs and redundancy — so it grows with you and doesn't fall over." },
  { id: "paloalto", vendor: "Palo Alto Networks", title: "Next-gen firewalls", back: "Your firewall understands apps and users, not just ports — stopping ransomware and data leaks before they reach your staff." },
  { id: "fortinet", vendor: "Fortinet", title: "FortiGate security", back: "Secure SD-WAN and threat protection set up properly — fast, safe links between every one of your sites." },
  { id: "azure", vendor: "Microsoft Azure", title: "Cloud computing", back: "Your offices connect securely to Microsoft 365 and Azure — hybrid networking done right, without slow VPN bottlenecks." },
  { id: "unifi", vendor: "Ubiquiti", title: "UniFi full stack", back: "Wi-Fi, cameras and doors on one dashboard with no licence fees — enterprise features at small-business prices." },
  { id: "meraki", vendor: "Cisco Meraki", title: "Cloud-managed SD-WAN", back: "Multi-site networks monitored and fixed remotely — problems are often sorted before you even notice them." },
];

const Card = ({ c, i }) => {
  const [flip, setFlip] = useState(false);
  return (
    <button
      type="button"
      onClick={() => setFlip((f) => !f)}
      onPointerEnter={(e) => e.pointerType === "mouse" && setFlip(true)}
      onPointerLeave={(e) => e.pointerType === "mouse" && setFlip(false)}
      aria-pressed={flip}
      data-testid={`cert-card-${c.id}`}
      className="group h-[230px] sm:h-[210px] w-[78%] shrink-0 snap-center sm:w-full text-left [perspective:1200px]"
    >
      <span className={`relative block h-full w-full transition-transform duration-700 [transform-style:preserve-3d] ${flip ? "[transform:rotateY(180deg)]" : ""}`}>
        <span className="absolute inset-0 flex flex-col justify-between border border-white/10 bg-[#0B0F17] p-6 [backface-visibility:hidden]">
          <span className="flex items-center justify-between font-mono text-[10px] tracking-[0.25em] text-slate-500">
            <span>CERT/0{i + 1}</span><RefreshCw size={12} className="text-slate-600 group-hover:text-cyan-300 transition-colors" />
          </span>
          <span>
            <span className="block font-mono text-[11px] uppercase tracking-[0.2em] text-cyan-300">{c.vendor}</span>
            <span className="mt-2 block font-display text-2xl font-bold">{c.title}</span>
          </span>
        </span>
        <span className="absolute inset-0 flex flex-col justify-between border border-cyan-300/40 bg-gradient-to-br from-[#0E1B24] to-[#0B0F17] p-6 [backface-visibility:hidden] [transform:rotateY(180deg)]" data-testid={`cert-card-back-${c.id}`}>
          <span className="font-mono text-[10px] tracking-[0.25em] text-emerald-400">WHAT IT MEANS FOR YOU</span>
          <span className="text-[15px] leading-relaxed text-slate-200">{c.back}</span>
        </span>
      </span>
    </button>
  );
};

export const CertWall = () => (
  <div className="mt-8 sm:mt-12 -mx-5 flex gap-4 overflow-x-auto px-5 pb-3 snap-x snap-mandatory [scrollbar-width:none] [&::-webkit-scrollbar]:hidden sm:mx-0 sm:grid sm:grid-cols-2 sm:overflow-visible sm:px-0 sm:pb-0" data-testid="cert-wall">
    {CERTS.map((c, i) => <Card key={c.id} c={c} i={i} />)}
  </div>
);
